import { get } from 'lodash';

import ACTIONS from 'state/constants';
import { getCurrentProduct } from 'state/selectors/pdp';

const titleUpdater = store => next => action => {
  // Perform Action
  next(action);

  // Update Page Title
  if (action.type === ACTIONS.SET_CURRENT_PRODUCT) {
    const state = store.getState();
    const product = getCurrentProduct(state);

    const title = get(product, 'pageTitle');

    if (title) {
      document.title = title;
    }
  }
};

export default titleUpdater;
